import { useFormContext } from 'react-hook-form'
import { TextInput } from '@hashicorp/react-mds/src/components/form/text-input'
import FieldWrapper from '../../field-wrapper'
import { formattedLabel, useErrorMessage } from '../../../utils'
import type { MarketoFormTextField } from '../../../types'

const Index = ({ field }: { field: MarketoFormTextField }) => {
	const {
		register,
		formState: { isSubmitSuccessful, isSubmitting },
	} = useFormContext()
	const error = useErrorMessage(field.id)

	return (
		<FieldWrapper fieldId={field.id}>
			<TextInput
				label={formattedLabel(field)}
				type="text"
				field={{ ...register(field.id), placeholder: field.hintText }}
				size="large"
				error={error}
				isRequired={field.required}
				disabled={isSubmitting || isSubmitSuccessful}
			/>
		</FieldWrapper>
	)
}

export default Index
